import { format, parse, parseISO, isValid, fromUnixTime, toDate } from 'date-fns';

export const normalise = {
    null(value) {
        return value?.toString().trim() || null;
    },
    upper(value) {
        return this.null(value)?.toUpperCase() || null;
    },
    lower(value) {
        return this.null(value)?.toLowerCase() || null;
    },
    num(value) {
        value = this.null(value);
        if (!value) return null;
        const num = Number(value);
        return isNaN(num) ? null : num;
    },
    bool(value) {
        value = this.null(value);
        return value === true || value === 'true' || value === 1 || value === '1';
    },
    date(value) {
        const date = d(value).date();
        return date;
    },
    search(value) {
        value = this.lower(value);
        return value?.normalize("NFD").replace(/[\u0300-\u036f]/g, "") || null; // Remove diacritics
    }
}

export const delay = async (ms) => {
    return new Promise((resolve) =>
        setTimeout(() => {
            resolve()
        }, ms)
    )
}

export const date = (value, parseFormat) => {
    const safeDate = (date) => {
        return {
            object: () => date ?? null,
            string: (resultFormat = 'yyyy-MM-dd') => date ? format(date, resultFormat) : null,
            date: () => date ? toDate(date) : null
        }
    }

    let date;
    value = value?.toString().trim();
    if (!value) return safeDate(null);

    if (!parseFormat) {
        date = parseISO(value);
    } else {
        switch (parseFormat) {
            case 'excel':
                const msPerDay = 86400000; // 1000 * 60 * 60 * 24
                const epochDiffDays = 25569; // Days between 1899-12-31 and 1970-01-01
                const unix = Math.round((value * 1 - epochDiffDays) * msPerDay, 0);
                date = fromUnixTime(unix / 1000);
                break;
            case 'unix-ms':
                date = fromUnixTime(value * 1 / 1000)
                break;
            case 'unix':
                date = fromUnixTime(value * 1)
                break;
            default:
                date = parse(value, parseFormat, new Date());
        }
    }

    if (!date) return safeDate(null);
    if (!isValid(date)) return safeDate(null);

    return safeDate(date);
}

export const validate = (value) => {
    if (!value) throw new Error('Invalid Data!');
    return value;
}

export default { date, normalise, delay, validate }